import AppDialog from "../../../components/Common/AppDialog";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";

export default function AddSalesman({ open, close, handleEdit, handleAdd, windowWidth, values, setFormValues, salesmanList, branchList, newSalesman, setNewSalesman, formObj, editIdx }) {
    return (
        <AppDialog
            title={'Add Salesman'}
            open={open}
            close={close}
            positiveTitle={editIdx !== null ? 'Save' : 'Add'}
            positivePress={() => editIdx === null ? handleAdd(values) : handleEdit(values)}
            cancelButton={true}
            width={'80%'}
            isMobile={windowWidth <= 768}
        >
            <CustomSelect
                title={'Salesman'}
                values={values?.salesman_id || '-1'}
                onChange={(e) => {
                    const selectedOption = salesmanList?.find((salesman) => salesman.id === e);
                    setFormValues({ ...values, salesman_id: e, contact: selectedOption?.phone || '', location_id: selectedOption?.branch_id || '', location_name: selectedOption?.branch_name || '' });
                }}
                data={salesmanList || []}
                labelName={'name'}
                valueName={'id'}
                placeholder={'Salesman'}
            />
            <CustomSelect
                title={'Branch'}
                values={values?.location_id || '-1'}
                onChange={(e) => { setFormValues({ ...values, location_id: e, location_name: branchList.find((location) => location.id === e)?.branch_name || '' }); }}
                data={branchList || []}
                labelName={'branch_name'}
                valueName={'id'}
                placeholder={'Branch'}
            />
            <CustomTextField
                title={'Contact'}
                values={values?.contact || values?.salesman_phone || "-"}
                onChange={(e) => { setFormValues({ ...values, contact: e, salesman_phone: e }); }}
                placeholder={'Contact'}
                disabled={true}
            />

        </AppDialog>
    )
}
